var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23410",
    "data-name": "Rectangle 23410",
    width: 40,
    height: 40,
    transform: "translate(14410 -2723)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Award",
    transform: "translate(-14410 2723)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "medal",
    transform: "translate(14392.25 -2722)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_567",
    "data-name": "Ellipse 567",
    cx: 15.088,
    cy: 15.088,
    r: 15.088,
    transform: "translate(23.076 0)",
    fill: "#ffd15c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66865",
    "data-name": "Group 66865",
    transform: "translate(20.75 23.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73241",
    "data-name": "Path 73241",
    d: "M25.941,319.7l-5.191,9,6.059-.322,2.753,5.408,4.8-8.326A15.073,15.073,0,0,1,25.941,319.7Z",
    transform: "translate(-20.75 -319.655)",
    fill: "#40596b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73242",
    "data-name": "Path 73242",
    d: "M313.45,319.1a15.078,15.078,0,0,1-8.4,5.79l4.817,8.341,2.753-5.408,6.059.322Z",
    transform: "translate(-283.783 -319.1)",
    fill: "#40596b"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_568",
    "data-name": "Ellipse 568",
    cx: 10.936,
    cy: 10.936,
    r: 10.936,
    transform: "translate(27.228 4.152)",
    fill: "#f8b64c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73243",
    "data-name": "Path 73243",
    d: "M166.218,109.872a.571.571,0,0,0-.314-.972l-4.316-.628a.563.563,0,0,1-.426-.314l-1.93-3.912a.57.57,0,0,0-1.025,0l-1.922,3.912a.594.594,0,0,1-.426.314l-4.316.628a.571.571,0,0,0-.314.972l3.119,3.044a.576.576,0,0,1,.165.5l-.733,4.294a.57.57,0,0,0,.83.6l3.86-2.027a.557.557,0,0,1,.531,0l3.86,2.027a.573.573,0,0,0,.83-.6l-.741-4.294a.563.563,0,0,1,.165-.5Z",
    transform: "translate(-120.559 -95.966)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/Award.d68fcb7aed5400700659aceb4c4887db.svg";
export { ForwardRef as ReactComponent };